import { render, staticRenderFns } from "./AccProductReactionCreateAction.vue?vue&type=template&id=764b5de6"
import script from "./AccProductReactionCreateAction.vue?vue&type=script&lang=js"
export * from "./AccProductReactionCreateAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports